import React from 'react';
import { RuleEngineAppProps } from 'src/frontend-common/dto/Interfaces/RuleEngine/RuleEngine';

export const useRuleEngine = () => {
  const FrontendAnalytics: React.FC<RuleEngineAppProps> = React.lazy(() => import('RuleEngine/RuleEngine'));
  return FrontendAnalytics;
};
